//@flow
import React, { useState, useEffect } from 'react';
import { ProjectActions } from 'modules/project/actions';
import { HomeActions } from 'modules/home/actions';
import { ProjectSelector } from 'modules/project/selector';
import { withRouter } from 'react-router-dom';
import { RouteNames } from 'router';
import { RouteUtil } from 'utils/RouteUtil';
import { ArchitectsSelector } from 'modules/shibaniKamalArchitecture/selector';
import { NavigationUtil } from 'utils/NavigationUtil';
import { HomeSelector } from 'modules/home/selector';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Title } from 'components/atoms/title';
import { filter, isEmpty } from 'lodash';
import { CardView } from 'components/molecules/card';
import { useViewport } from 'components/templates/viewportProvider';
import { OverlayModal } from 'components/templates/overlayModal';
import { OverlayPortal } from 'components/templates/overlayPortal';
import './styles.scss';
import { AwardActions } from 'modules/awards/action';
import { AwardSelector } from 'modules/awards/selector';
type Props = {
  mediaPath: string,
  type: string,
};
const GridView = (props: Props) => {
  const {
    data,
    type,
    awardData,
    verticalId,
    projectOverlayData,
    getVerticals,
    getAwardData,
  } = props;
  const [showArchitectOverlay, setShowArchitectOverlay] = useState(false);
  const list =
    type === 'projects' || type === 'architecture-projects' ? data.list : data;
  const text =
    type === 'projects' || type === 'architecture-projects'
      ? list.length === 1
        ? 'property'
        : 'properties'
      : list.length === 1
      ? 'unique home layout'
      : 'unique home layouts';
  const architectOverlayData = projectOverlayData ? projectOverlayData : [];
  const [filteredArchitectData, setFilteredArchitectData] = useState([]);
  let cityIds = [];
  const [projectAwardData, setProjectAwardData] = useState([]);
  if (type === 'projects' || type === 'architecture-projects') {
    cityIds = list.map(project => project.cityId);
  } else if (type === 'products') {
    cityIds = list.reduce((ids, product) => {
      const projects = product.detailCard.projects;
      const projectCities = projects.map(project => project.cityId);
      ids.push(...projectCities);
      return ids;
    }, []);
  }

  const locationsCount = new Set(cityIds).size;
  const locationsText =
    locationsCount === 1
      ? `${locationsCount} location`
      : `${locationsCount} locations`;

  const goToProjectDetails = project => {
    let currentRoute = props.location.pathname;
    if (currentRoute === RouteNames.workcations) {
      RouteUtil.setRouteChange(
        props,
        `${RouteNames.workcations}/${project.urlSlug}`,
        '',
        '',
        project.id
      );
    }
    if (currentRoute === RouteNames.homes) {
      RouteUtil.setRouteChange(
        props,
        `/${project.urlSlug}`,
        '',
        '',
        project.id
      );
    } else{
      let overlayData = filter(
        architectOverlayData,
        data => data.project_id === project.id
      );
      setProjectAwardData(
        filter(awardData, data => data.project_id === project.id)
      );
      if (overlayData.length > 0) {
        overlayData[0].title = list.name;
      }
      setFilteredArchitectData(overlayData);
      !isEmpty(overlayData) && setShowArchitectOverlay(true);
    }
  };

  const goToProductDetails = product => {
    RouteUtil.setRouteChange(
      props,
      `/homes/${product.url_slug}`,
      '',
      '',
      product.id
    );
  };

  const goToCareerDetails = job => {
    const locationPath = props.location;
    RouteUtil.setRouteChange(
      props,
      `/careers/${job.urlSlug}`,
      locationPath.hash,
      locationPath.pathname
    );
  };

  const renderArchitectOverlay = showArchitectOverlay ? (
    <OverlayPortal>
      <OverlayModal
        data={filteredArchitectData}
        awardData={projectAwardData}
        theme={'light-theme'}
        type={'architect-project'}
        className={'architectOverlay'}
        onClosePress={() => setShowArchitectOverlay(false)}
        breadcrumbList={[
          {
            breadcrumbName: 'Shibanee & Kamal',
            breadcrumbLink: 'Shibanee',
          },
        ]}
      />
    </OverlayPortal>
  ) : null;
  return (
    <div className={'grid-view-container'}>
      <Row className={'grid-view-header'}>
        {type === 'view-all-roles' ? (
          <h3>View All Roles</h3>
        ) : (
          <Title
            firstText={`${list.length} ${text}`}
            secondText={`${locationsText}`}
          />
        )}
      </Row>
      <Row className={'grid-view-content'}>
        {type === 'projects' &&
          list.map((project, idx) => (
            <Col md={4} key={idx} className={'card-section'}>
              <CardView
                data={{
                  name: project.project_name,
                  city: project.city,
                  country: project.country,
                  imagePath: project.listImageUrl,
                }}
                height={`calc(85% - 2.45833vw)`}
                type={type}
                onClick={() => goToProjectDetails(project)}
              />
            </Col>
          ))}
        {type === 'architecture-projects' &&
          list.map((project, idx) => (
            <Col md={4} key={idx} className={'card-section'}>
              <CardView
                data={{
                  name: project.project_name,
                  city: project.city,
                  country: project.country,
                  imagePath: project.listImageUrl,
                }}
                height={`calc(85% - 2.45833vw)`}
                type={type}
                onClick={() => goToProjectDetails(project)}
              />
            </Col>
          ))}
        {type === 'products' &&
          list.map((product, idx) => (
            <Col md={4} key={idx} className={'card-section'}>
              <CardView
                data={product}
                type={type}
                height={`calc(85% - 2.45833vw)`}
                background={'linear-gradient(#1c2023, #1c2023)'}
                onClick={() => goToProductDetails(product.detailCard)}
                containerClass={'product'}
              />
            </Col>
          ))}
        {type === 'view-all-roles' &&
          list.map((data, idx) => (
            <Col md={4} key={idx} className={'card-section'}>
              <CardView
                data={data}
                type={type}
                height={`calc(85% - 2.45833vw)`}
                background={'linear-gradient(#1c2023, #1c2023)'}
                onClick={() => goToCareerDetails(data)}
                customClass={'job-post-card-data'}
              />
            </Col>
          ))}
      </Row>
      {renderArchitectOverlay}
    </div>
  );
};
const mapStateToProps = (state, props) => {
  const { product } = props.data;
  const verticalKey = NavigationUtil.getVerticalKeyForLocation(props.location);

  return {
    awardData: AwardSelector.getAwardData(state),
    projectOverlayData: ArchitectsSelector.getProjectOverlay(state),
    verticalId: HomeSelector.getVerticalIdForKey(verticalKey),
    verticals: HomeSelector.getVerticals(state),
  };
};

const mapDispatchToProps = dispatch => {
  // const { toggleProjectFilter, clearProjectFilters } = ProjectActions;
  const { getAwardData } = AwardActions;
  const { getVerticals } = HomeActions;
  return bindActionCreators(
    {
      getAwardData,
      getVerticals,
    },
    dispatch
  );
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(GridView);

export default withRouter(connectedComponent);
